import { spacing } from "./spacing";
export const margin = {
  ...spacing,
};
